// extracted by mini-css-extract-plugin
export var menuIcon = "_sa-0";
export var menuIconInline = "_sa-1";